import { SECURITY_CODE_NAMESPACE } from "@/utils/history";

export function makeSecurityCodeKey(nation: string) {
  return SECURITY_CODE_NAMESPACE + "_" + nation;
}
